import graphqlClient from './client';
import getMemberToken from '../../utils/getMemberToken';
import UPDATE_WEDDING_WEBSITE_MUTATION from './graphql/updateWeddingWebsiteMutation';
import WEDDING_WEBSITE_QUERY from './graphql/weddingWebsiteQuery';

const getHeaders = () => ({
  token: getMemberToken(),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

const WeddingWebsiteGraphQL = {
  getWeddingWebsite: async () => {
    const requestHeaders = getHeaders();

    try {
      const {weddingWebsite} = await graphqlClient.request({
        document: WEDDING_WEBSITE_QUERY,
        requestHeaders,
      });
      return {
        weddingWebsite,
        error: null,
      };
    } catch (error) {
      return {weddingWebsite: null, error};
    }
  },

  updateWeddingWebsite: async registryNote => {
    const requestHeaders = getHeaders();

    try {
      const {updateWeddingWebsite} = await graphqlClient.request({
        document: UPDATE_WEDDING_WEBSITE_MUTATION,
        requestHeaders,
        variables: {
          attributes: {registryNote},
        },
      });
      return {weddingWebsite: updateWeddingWebsite, error: null};
    } catch (error) {
      return {weddingWebsite: null, error};
    }
  },
};

export default WeddingWebsiteGraphQL;
